<template>
  <el-popover v-model="visible"
              placement="bottom-start"
              width="430"
              trigger="click"
              popper-class="address-library-selector-popover">
    <div class="address-library-selector-panel">
      <div class="search-row">
        <el-input v-model="keyword"
                  size="mini"
                  clearable
                  placeholder="搜索地址名称或授课地点">
          <template #append>
            <el-button size="mini"
                       icon="el-icon-search"
                       @click="loadOptions"></el-button>
          </template>
        </el-input>
      </div>
      <div v-loading="loading"
           class="option-list">
        <div v-for="item in filteredOptions"
             :key="item.id"
             class="option-item"
             @click="handleSelect(item)">
          <div class="option-title">
            <div class="option-name">{{item.name}}</div>
            <el-tag v-if="item.siteName"
                    size="mini"
                    type="info">{{item.siteName}}</el-tag>
          </div>
          <div class="option-address">{{item.address}}</div>
          <div v-if="item.tencentMapLocation"
               class="option-location">{{item.tencentMapLocation}}</div>
        </div>
        <div v-if="!loading && !filteredOptions.length"
             class="empty-text">暂无可选地址</div>
      </div>
    </div>
    <template slot="reference">
      <el-button size="mini"
                 plain
                 icon="el-icon-collection"
                 :disabled="!siteId"
                 title="从地址库选择授课地点">从地址库选择</el-button>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: 'AddressLibrarySelector',
  props: {
    siteId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      keyword: '',
      options: []
    }
  },
  computed: {
    filteredOptions () {
      const keyword = this.keyword.trim().toLowerCase()
      if (!keyword) {
        return this.options
      }
      return this.options.filter(item => {
        return String(item.name || '').toLowerCase().includes(keyword) ||
          String(item.address || '').toLowerCase().includes(keyword) ||
          String(item.siteName || '').toLowerCase().includes(keyword)
      })
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.loadOptions()
      }
    },
    siteId () {
      this.options = []
      this.keyword = ''
      if (this.visible) {
        this.loadOptions()
      }
    }
  },
  methods: {
    loadOptions () {
      if (!this.siteId || this.loading) {
        return
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/arrange/address/options',
        method: 'post',
        data: this.$qs.stringify({
          siteId: this.siteId
        })
      }).then(response => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.options = response.data.options || []
        } else if (response.data) {
          this.$message.warning(response.data.message)
        }
      }, () => {
        this.$message.error('地址库加载失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelect (item) {
      this.$emit('select', item)
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.address-library-selector-popover {
  padding: 0;

  .address-library-selector-panel {
    .search-row {
      padding: 12px;
      border-bottom: 1px solid #ebeef5;
    }

    .option-list {
      max-height: 300px;
      overflow-y: auto;
    }

    .option-item {
      padding: 10px 12px;
      border-bottom: 1px solid #f2f6fc;
      cursor: pointer;

      &:hover {
        background: #f5f7fa;
      }

      .option-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }

      .option-name {
        min-width: 0;
        overflow: hidden;
        color: #303133;
        font-size: 13px;
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .el-tag {
        flex: none;
      }

      .option-address,
      .option-location {
        margin-top: 4px;
        color: #606266;
        font-size: 12px;
        line-height: 18px;
        word-break: break-all;
      }

      .option-location {
        color: #909399;
        font-family: monospace;
      }
    }

    .empty-text {
      padding: 28px 12px;
      color: #909399;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
